<template>
  <b-modal
    v-loading="loading"
    ref="modal"
    :visible="true"
    :title="title"
    @hide="close"
    size="lg"
  >
    <div>
      <div
        class="p-3"
        v-for="(log, index) in logs"
        :key="index"
        style="border-bottom: 1px solid #c2cfd6"
      >
        <div v-if="log.isJson" class="">
          <div class="pb-3 row">
            <span class="col-9 bold">
              Log Id :
              {{ log.id ? log.id : "N/A" }}
            </span>
            <span class="col-3 bold">
              Date :
              {{ log.date ? $getFormattedDate(log.date) : "N/A" }}
            </span>
          </div>
          <div class="row">
            <div v-for="(value, key) in log.log" :key="key" class="col-4 pb-3">
              <span
                style="color: #536c79"
                class="row pl-3 text-capitalize small"
              >
                {{ key }} :
              </span>
              <span class="row pl-3">
                {{ value ? value : "N/A" }}
              </span>
            </div>
          </div>
        </div>
        <div v-else class="text-center">{{ log.log }}</div>
      </div>
    </div>
    <template slot="modal-footer">
      <button type="button" class="btn btn-secondary" @click.prevent="close">
        {{ $t("Close") }}
      </button>
    </template>
  </b-modal>
</template>

<script>
import ApiService from "../services/ApiService";
import DateFormatFiltersMixin from "../mixins/DateFormatFiltersMixin";
export default {
  name: "AppPagePlanEdit",
  mixins: [DateFormatFiltersMixin],
  data() {
    return {
      loading: true,
      logs: [],
      logsData: [],
      isJasonLog: false,
    };
  },
  computed: {
    title() {
      return `${this.$tc("View Logs", 1)}`;
    },
  },
  mounted() {
    this.load();
  },
  methods: {
    load() {
      ApiService.request("GET", "actions", {
        account_id: this.$route.params.id,
        object_id: this.$route.params.log_id,
      })
        .then((response) => {
          if (response.status === 200 && response.data.length > 0) {
            this.logsData = response.data;
            console.log(this.logsData);
            if (this.logsData.length > 0) {
              this.logsData.forEach((logInfo) => {
                try {
                  const parsedJson = JSON.parse(logInfo.log);
                  let result = this.flattenLogs(parsedJson);
                  this.logs.push({ id: logInfo.id, date: logInfo.created_at, log: result, isJson: true });
                } catch {
                  let log = {
                    orderId: logInfo.object_id,
                    action: logInfo.action,
                  };
                  this.logs.push({
                    id: logInfo.id,
                    date: logInfo.created_at,
                    log: log,
                    isJson: true,
                  });
                } finally {
                  this.loading = false;
                }
              });
            } else {
              console.log("No logs found");
              this.logs.push({
                log: "No logs found",
                isJson: false,
              });
              this.loading = false;
            }
          } else {
            console.log("error");
            console.log("No logs found");
            this.logs.push({
              log: "No logs found",
              isJson: false,
            });
            this.loading = false;
          }
        })
        .catch(() => {
          console.log("error");
        });
    },
    flattenLogs(obj) {
      const result = {};
      function flattenRecursively(obj, prefix = "") {
        for (const key in obj) {
          if (obj.hasOwnProperty(key)) {
            const value = obj[key];
            const newKey = key;
            if (
              typeof value === "object" &&
              value !== null &&
              !Array.isArray(value)
            ) {
              flattenRecursively(value, newKey);
            } else if (Array.isArray(value)) {
              for (const item of value) {
                if (
                  typeof item === "object" &&
                  item !== null &&
                  !Array.isArray(item)
                ) {
                  flattenRecursively(item, newKey);
                }
              }
            } else {
              result[newKey] = value;
            }
          }
        }
      }
      flattenRecursively(obj);
      return result;
    },
    close() {
      this.$router.back();
    },
  },
};
</script>
